import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { AppService } from "../../../core/services/app.service"
import { ClassCreateUpdateRequest } from "../models/class/class-create-update-request"
import { ClassCreatePayload } from "../models/class/class-create-payload"
import { ClassUsersGetResponse } from "../models/class/class-users-get-response"
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http"
import { ClassPaginateRequest } from "../models/class/class-paginate-request"
import { ClassDemandUpdateRequest } from "../models/class/class-demand-update-request"
import {
  CustomURLEncoder,
  toHttpParams,
} from "src/app/core/helpers/http-params-extensions"
import { HEADERS } from "./const/http-header-interception"
import { Observable, of } from "rxjs"
import TurnGetResponse from "../models/turn/turn-get-response"
import { ProfilesByClassId } from "@app/shared/interfaces/profile-by-classId"

@Injectable()
export class ClassService {
  private post_class_url: string
  private get_class_paginate_url: string
  private get_all_turns: string
  private get_class_id_url: string
  private put_class_url: string
  private post_course_onclass_url: string
  private get_membership_card_url: string
  private get_classes_url: string
  private post_class_export_pdf_url: string

  private get_profiles_by_class =
    environment.endpointBackoffice.url +
    environment.endpointBackoffice.routes.get_profiles_by_class

  private buildUrls(classUrl: string) {
    this.post_class_url = classUrl + environment.endpointClass.routes.post_class
    this.get_class_paginate_url =
      classUrl + environment.endpointClass.routes.get_class_paginate_grade
    this.get_all_turns =
      classUrl + environment.endpointClass.routes.get_all_turns
    this.get_class_id_url =
      classUrl + environment.endpointClass.routes.get_class_id
    this.put_class_url = classUrl + environment.endpointClass.routes.put_class
    this.post_course_onclass_url =
      classUrl + environment.endpointClass.routes.post_course_on_class
    this.get_classes_url =
      environment.endpointClassesForm.url +
      environment.endpointClassesForm.routes.get_classes
    this.post_class_export_pdf_url =
      environment.endpointBackofficeGateway.url +
      environment.endpointBackofficeGateway.routes.export_class_pdf
  }
  private buildExportClassUrl(classUrl: string) {
    this.get_membership_card_url =
      classUrl + environment.endpointBackoffice.routes.export_pdf
  }

  constructor(private httpClient: HttpClient, private appService: AppService) {
    this.buildUrls(environment.endpointClass.url)
    this.buildExportClassUrl(environment.endpointBackoffice.url)
  }

  post(model: ClassCreatePayload) {
    return this.httpClient.post(this.post_class_url, model)
  }

  getOneClass(id: string) {
    return this.httpClient.get(this.get_class_id_url.replace("{classId}", id))
  }

  getMany(ids: string[]): Observable<ClassUsersGetResponse[]> {
    return this.httpClient.post<ClassUsersGetResponse[]>(
      `${environment.endpointClass.url}${environment.endpointClass.routes.get_many}`,
      ids
    )
  }

  getPaginate(classPaginateRequest: ClassPaginateRequest) {
    const { grades, ...others } = classPaginateRequest
    let params = toHttpParams(others)
    for (let i = 0, j = grades ? grades.length : 0; i < j; ++i) {
      params = params.append(`grades[${i}]`, grades[i])
    }
    return this.httpClient.get(this.get_class_paginate_url, { params })
  }

  getAllTurns(schoolId: string): Observable<TurnGetResponse[]> {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    if (schoolId) {
      params = params.set("SchoolId", schoolId)
    }

    return this.httpClient.get<TurnGetResponse[]>(this.get_all_turns, {
      params,
    })
  }

  getInterceptorError() {
    return new HttpHeaders({
      "x-intercept-error": "true",
    })
  }

  put(model: ClassCreateUpdateRequest) {
    const headers = this.getInterceptorError()
    return this.httpClient.put(
      this.put_class_url.replace("{classId}", model.id),
      model,
      { headers }
    )
  }

  postCourseOnClass(model: ClassDemandUpdateRequest) {
    const headers = this.getInterceptorError()
    return this.httpClient.post(this.post_course_onclass_url, model, {
      headers,
    })
  }

  downloadMembershipCard(listClassId): Observable<any> {
    return this.httpClient.post(this.get_membership_card_url, listClassId, {
      headers: new HttpHeaders(HEADERS),
    })
  }

  postClassCardInfo(listClassId) {
    return this.httpClient.post(this.post_class_export_pdf_url, listClassId, {
      headers: new HttpHeaders(HEADERS),
    })
  }

  checkChangingYear(): Observable<boolean> {
    //TO-DO ENDPOINT NO CONTEXTO DA ESCOLA
    return of(true)
  }

  getClassesByQueryParams(
    schoolId: string,
    customParams?: Array<{ name: string; value: string }>
  ) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    if (customParams)
      customParams.forEach(
        (param) => (params = params.set(param.name, param.value))
      )
    return this.httpClient.get(
      this.get_classes_url.replace("{schoolId}", schoolId),
      { params, headers: new HttpHeaders(HEADERS) }
    )
  }

  getProfilesbyClassId(classId: string): Observable<ProfilesByClassId> {
    return this.httpClient.get<ProfilesByClassId>(
      this.get_profiles_by_class.replace("{classId}", classId)
    )
  }
}
